import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Head from '@/components/feature/Head';
import Hero from './components/Hero';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  const webPageSchema = {
    name: '韩漫在线免费 - 首页',
    description: '韩漫在线免费为您提供海量好看的韩国漫画大全资源，支持下拉式在线阅读体验。收录恋爱、奇幻、动作、悬疑等全类型韩漫。',
    url: 'https://www.koreancomics.cn',
  };

  return (
    <>
      <Head
        title="韩漫在线免费_好看的韩国漫画大全_阅读下拉式韩漫-韩国漫画网站"
        description="韩漫在线免费为您提供海量好看的韩国漫画大全资源，支持下拉式在线阅读体验。韩国漫画网站收录恋爱、奇幻、动作、悬疑、搞笑、剧情、耽美、百合等全类型韩漫，更新及时，随时随地享受精彩故事并追更人气系列。"
        keywords="韩漫在线免费, 韩国漫画大全, 下拉式阅读, 韩国漫画网站, 韩漫, 韩国漫画, 免费漫画, 在线漫画"
        canonical="https://www.koreancomics.cn"
      />

      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" data={webPageSchema} />

      <Navbar />
      <main>
        <Hero />
        <FeaturedComics />
        <CategorySection />
        <LatestUpdates />
        <TestimonialsSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}